import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/singleselect.vue'
import moment from 'moment'
import datePicker from '../../component/datePicker.vue'

if ($('#invoice_verify_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#invoice_verify_form',
    components: {
      RingLoader,
      Singleselect,
      moment,
      datePicker
    },
    mixins: [mixins],
    data: {
      loading: 0,
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      selectedSupplier: false,
      suppliers: [],
      errors: {},
      resultContent: '',
    },
    mounted: function () {
      this.loading++

      this.getSupplier()

      this.loading--
    },
    methods: {
      verifyInvoice: function() {
        let url = Routing.generate('purchase_report_invoice_verify_result')

        let data = {
          data: {
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            supplier: this.selectedSupplier,
          }
        }
        this.loading++

        this.$http.post(url, data).then(response => {
          this.errors = {}
          this.resultContent = response.body

          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getSupplier: function() {
        this.loading++
        let url = Routing.generate('api_get_suppliers', { context: 'dropdown' })

        this.$http.get(url).then(response => {
          this.suppliers = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })
}
